<template>
    <div class="cancelBox" id="scroll" :class="rankType==2?'pinkBox':''">
        <div class="giftBox">
            <header v-if="rankType==1">{{ $t('top1VIPRewards') }}</header>
            <header v-else>{{ $t('top1AnchorRewards') }}</header>
            <div class="giftItem">
                <div class="giftInfo">
                    <img v-if="rankType==2" src="../../assets/overallRankGift/2_top1_1.png" alt="">
                    <img v-else src="../../assets/overallRankGift/1_top1.png" alt="">
                    <span></span>
                </div>
                <div class="podiumBox">
                    <span></span>
                    <div>
                      <p>
                        <span v-html="$t('top1Icon7day')"></span>
                      </p>
                    </div>
                    
                </div>
            </div>
            <div class="giftItem">
                <div class="giftInfo">
                    <img v-if="rankType==2" src="../../assets/overallRankGift/2_top1_2.png" alt="">
                    <img v-else src="../../assets/overallRankGift/1_top1_2.png" alt="">
                    <span></span>
                </div>
                <div class="podiumBox">
                    <span></span>
                    <div>
                      <p>
                        <span v-html="$t('top1_2Icon7day')"></span>
                      </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="giftBox">
            <header v-if="rankType==1" v-html="$t('top2_3VIPRewards')"></header>
            <header v-else v-html="$t('top2_3AnchorRewards')"></header>
            <div class="giftItem">
                <div class="giftInfo">
                    <img v-if="rankType==2" src="../../assets/overallRankGift/2_top2.png" alt="">
                    <img v-else src="../../assets/overallRankGift/6015.png" alt="">
                    <span></span>
                </div>
                <div class="podiumBox">
                    <span></span>
                    <div>
                      <p>
                        <span v-html="$t('top1Icon7day')"></span>
                      </p>
                    </div>
                    
                </div>
            </div>
            <div class="giftItem">
                <div class="giftInfo">
                    <img v-if="rankType==2" src="../../assets/overallRankGift/1_top2.png" alt="">
                    <img v-else src="../../assets/overallRankGift/1_top2.png" alt="">
                    <span></span>
                </div>
                <div class="podiumBox">
                    <span></span>
                    <div>
                      <p>
                        <span v-html="$t('top1_2Icon7day')"></span>
                      </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="giftBox top3GiftBox">
            <header v-if="rankType==1" v-html="$t('top4_10VIPRewards')"></header>
            <header v-else v-html="$t('top4_10AnchorRewards')"></header>
            <div class="giftItem">
                <div class="giftInfo">
                    <img v-if="rankType==2" src="../../assets/overallRankGift/2_top2.png" alt="">
                    <img v-else src="../../assets/overallRankGift/1_top2.png" alt="">
                    <span></span>
                </div>
                <div class="podiumBox">
                    <span></span>
                    <div>
                      <p>
                        <span v-html="$t('top1_2Icon7day')" v-if="rankType==1"></span>
                        <span v-html="$t('top1Icon7day')" v-else></span>
                      </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
  </template>
  
  <script>
  export default {
    name: "overallRankGift",
    data() {
      return {
        langType: "",
        rankType:''
      };
    },
    created() {
        this.langType = this.$route.query.langType;
        this.rankType = this.$route.query.rankType;
        this.language()
    },
    mounted() {

    },
    methods: {
        language() {
            let langs = this.langType.substring(0, 2);
            let lang = this.langType;
            if (langs == "zh") {
                if (lang == "zh_TW" || lang == "zh_HK") {
                this.$i18n.locale = "tc";
                } else {
                this.$i18n.locale = "zh";
                }
            } else if (langs == "en") {
                this.$i18n.locale = "en";
            } else if (langs == "ar") {
                this.$i18n.locale = "ar";
            }else if (langs == "tr") {
                this.$i18n.locale = "tr";
            } else if (langs == "es") {
                this.$i18n.locale = "es";
            } else if (langs == "pt") {
                this.$i18n.locale = "pt";
            } else if (langs == "fr") {
              this.$i18n.locale = "fr"
            } else if (langs == "id") {
              this.$i18n.locale = "id"
            } else if (langs == "ms") {
              this.$i18n.locale = "ms"
            } else {
              this.$i18n.locale = "en";
            }
             document.querySelector("html").setAttribute("lang", this.$i18n.locale);
        },
    },
  };
  </script>
  
  <style>
html[lang="ar"] .body {
  direction: rtl;
}

html[lang="ar"] .pay {
  direction: rtl;
}
  /* html[lang="ar"] .cancelBox {
  -webkit-transform: rotateY(180deg);
}
html[lang="ar"] .giftInfo img{
  transform: scaleX(-1);
} */
html[lang="ar"] .giftBox header span,html[lang="ar"] .podiumBox p>span>span{
    display: inline-block;
    transform: scaleX(-1);
}
  * {
    margin: 0;
    padding: 0;
  }
  .cancelBox{
    width: 6.4rem;
    height: 11.12rem;
    padding-top: 1.0rem;
    background: url('../../assets/overallRankGift/bg.png') no-repeat;
    background-size: 6.4rem 11.12rem;
    box-sizing: border-box;
    overflow: auto;
  }
  .giftBox{
    width: 5.84rem;
    height: 4.3rem;
    border-radius: 0.2rem;
    margin: 0 auto;
    background: linear-gradient(to bottom, #FFCD71CC 0%, #FFD495CC 100%);
    border: 0.02rem solid #fff;
    position: relative;   
     display: flex;
    justify-content: space-between;
    margin-bottom: 0.76rem;
    padding: 0 0.25rem;
    box-sizing: border-box;
  }

  .giftBox header{
    font-size: 0.28rem;
    line-height: 0.6rem;
    height: 0.6rem;
    padding: 0 0.34rem;
    box-sizing: border-box;
    background: linear-gradient(to bottom, #FFDC5F 0%, #E8771A 100%);
    border: 0.02rem solid #fff;
    border-radius: 0.3rem;
    font-family: Montserrat;
    font-weight: 400;
    color: #fff;
    position: absolute;
    top: -0.3rem;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
  }
  .giftBox header::before{
    position: absolute;
    left: -0.24rem;
    top: 50%;
    transform: translateY(-50%);
    content: '';
    width: 0.48rem;
    height: 0.48rem;
    background: url('../../assets/overallRankGift/start.svg') no-repeat;
    background-size: 100% 100%;
  }
  .giftBox header::after{
    position: absolute;
    right: -0.24rem;
    top: 50%;
    transform: translateY(-50%);
    content: '';
    width: 0.48rem;
    height: 0.48rem;
    background: url('../../assets/overallRankGift/start.svg') no-repeat;
    background-size: 100% 100%;
  }
  .giftItem{
    margin-top: 0.68rem;
    width: 2.44rem;
  }
  .giftInfo{
    position: relative;
    width: 2rem;
    height: 2rem;
    margin: 0 auto;
  }
  .giftInfo img{
    display: block;
    width: 1.46rem;
    height: 1.46rem;
    position: absolute;
    top: 0.27rem;
    left: 0.27rem;
    z-index: 1;
  }
  .giftInfo span{
    width: 2rem;
    height: 2rem;
    background: url('../../assets/overallRankGift/mask.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .podiumBox{
    margin-top: 0.05rem;
    
  }
  .podiumBox>span:nth-of-type(1){
    display: block;
    width: 2.4rem;
    height: 0.8rem;
    background: url('../../assets/overallRankGift/podium.png') no-repeat;
    background-size: 100% 100%;
  }
  .podiumBox>div{
    font-size: 0.24rem;
    line-height: 0.72rem;
    font-family: Montserrat;
    font-weight: 500;
    width: 2.44rem;
    height: 0.72rem;
    background: url('../../assets/overallRankGift/textBg.png') no-repeat;
    background-size: 100% 100%;
    text-align: center;
    margin-top: -0.2rem;
    margin-left: -0.02rem;
    color: #3B0000;
    box-sizing: border-box;
  }
  .podiumBox p{
    width: 80%;
    margin: 0 auto;
    overflow: hidden; /* 隐藏超出容器的文本 */
  }

  .podiumBox p>span{
    display: block;
    white-space: nowrap; /* 确保文本不换行 */
    animation: scroll 5s linear infinite; /* 应用滚动动画 */
  }
  html[lang="zh"] .podiumBox p span{
    animation: none;
  }
  html[lang="tc"] .podiumBox p span{
    animation: none;
  }
  @keyframes scroll {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
    }
  }
  .top3GiftBox{
    justify-content: center;
  }
  .pinkBox{
    background: url('../../assets/overallRankGift/pinkBg.png') no-repeat;
    background-size: 100% 100%;
  }
  .pinkBox .giftBox header{
    background: linear-gradient(to bottom, #FF8C7C 0%, #EB4949 100%);
  }
  .pinkBox .giftBox{
    background: linear-gradient(to bottom, #FF8C7C 0%, #EB4949 100%);
  }
  .pinkBox .podiumBox>div{
    background: url('../../assets/overallRankGift/pinkTextBg.png') no-repeat;
    background-size: 100% 100%;
  }
  .pinkBox .podiumBox>span:nth-of-type(1){
    display: block;
    width: 2.4rem;
    height: 0.8rem;
    background: url('../../assets/overallRankGift/podium2.png') no-repeat;
    background-size: 100% 100%;
  }
  </style>
  